/* eslint-disable */
// @ts-nocheck

import { useContext, useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import useServer from '../../../api/useServerMain'
import useServerProduct from '../../../api/useServerProducts'
import Checkbox from '../../../components/forms/Checkbox'
import TextArea from '../../../components/forms/TextArea'
import Button from '../../../components/misc/Button'
import GenericTable from '../../../components/misc/GenericTable'
import SelectInTwoTables from '../../../components/misc/SelectInTwoTables'
import SpinnerLoading from '../../../components/misc/SpinnerLoading'
import { SelectInterface } from '../../../interfaces/InterfacesLocal'
import {
  BasicNomenclator,
  ProductInterface,
} from '../../../interfaces/ServerInterfaces'
import { DetailProductContext } from '../DetailProductContainer'

interface Addon {
  product: ProductInterface | null
}

const Addon = () => {
  const { denyRoles } = useServer()
  const { getAllProducts, allProducts, outLoading } = useServerProduct()
  const { product, updateProduct } = useContext(DetailProductContext)
  const [selected, setSelected] = useState<BasicNomenclator[]>([])

  useEffect(() => {
    getAllProducts({ type: 'ADDON', all_data: true })
    setSelected(product?.availableAddons.map((item) => item) ?? [])
  }, [])

  //Checkbox Management-----------------------------------------------------------------------------------
  const checkData: {
    id: number
    name: string
    addicionalInfo?: string
  }[] = []
  allProducts.map((item) =>
    checkData.push({
      id: item.id,
      name: item.name,
    })
  )

  //-------------------------------------------------------------------------------------------------------

  const { control, handleSubmit } = useForm()

  const onSubmit: SubmitHandler<Record<string, string | number | boolean>> = (
    data
  ) => {
    const { elaborationSteps } = data

    updateProduct &&
      updateProduct(product?.id, {
        availableAddons: selected.map((item) => item.id),
        elaborationSteps,
      })
  }

  if (outLoading)
    return (
      <div className="flex h-[34rem] items-center justify-center">
        <SpinnerLoading />
      </div>
    )
  return (
    <>
      <form
        className="flex h-full flex-col items-stretch"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="h-[34rem] overflow-auto rounded-md scrollbar-thin scrollbar-thumb-gray-200">
          {/* <GenericTable
            tableData={[]}
            tableTitles={tableTitle}
            actions={costActions}
            rowAction={() => {}}
          /> */}

          <SelectInTwoTables
            data={checkData}
            heigthFull={true}
            loading={outLoading}
            rigthTableText="Agregos activos"
            selectedItems={selected}
            setSelectedItems={setSelected}
          />
        </div>
        {denyRoles(['AUDITOR']) && (
          <div className="flex justify-end py-2">
            <Button color="slate-600" name="Actualizar" type="submit" />
          </div>
        )}
      </form>
    </>
  )
}

export default Addon
